module.exports = __webpack_public_path__ + "static/img/Deyubg_02.edd95ae8.jpg";